import { Fragment } from "react"
import { minifyAddress } from "@/utils/common-utils"

const ContributeInfo = ({data}) => {
    if (data) {
        const renderItemValue = (e) => {
            if (e.type && e.type == "tx") {
                return (
                    <a href={e.link} target={e.target} className="text-primary">
                        <div className="flex items-center justify-center rounded-lg bg-lightMossGreen px-2 lg:px-4 lg:py-1">
                            <span>{minifyAddress(e.value)}</span>
                        </div>
                    </a>
                )
            } else {
                return (
                    <div className="text-right">
                        <span className="text-primary">{e.value}</span>
                    </div>
                )
            }
        }
        return (
            <div className={
                "ring-2 ring-white rounded-xl flex flex-col px-4 md:px-8 py-4  md:py-8 space-y-5 w-full"
            }>
                {
                    data.map((e, index) => {
                        return (
                            <div className="flex flex-row justify-between items-center w-full font-medium text-primary text-xs md:text-sm" key={index.toString()}>
                                <div><span className="text-primary/[.38]">{e.title}</span></div>
                                { renderItemValue(e) } 
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    return null
}

export default ContributeInfo